export default __webpack_public_path__ + "static/media/ICChatWidget.8e90ff67.svg";